import { render, staticRenderFns } from "./ElementVideoComp.vue?vue&type=template&id=1a056a82&scoped=true&"
import script from "./ElementVideoComp.vue?vue&type=script&lang=js&"
export * from "./ElementVideoComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a056a82",
  null
  
)

export default component.exports